import template from './riccardo-deal-detail.html.twig';

const { Criteria } = Shopware.Data;
const { Mixin } = Shopware;

export default {
    template,

    inject: ['repositoryFactory'],

    mixins: [Mixin.getByName('notification')],

    props: {
        dealId: { type: String, required: false, default: null },
    },

    data() {
        return {
            deal: null,
            isLoading: false,
            isSaveSuccessful: false,
        };
    },

    metaInfo() {
        return { title: this.$createTitle(this.deal?.name) };
    },

    computed: {
        dealRepository() {
            return this.repositoryFactory.create('riccardo_deal');
        },

        priceTypeOptions() {
            return [
                { value: 'fixed', label: this.$t('riccardo-deal.detail.priceType_fixed') },
                { value: 'percent', label: this.$t('riccardo-deal.detail.priceType_percent') },
            ];
        },

        behaviorOptions() {
            return [
                { value: 'normal_price', label: this.$t('riccardo-deal.detail.behavior_normal_price') },
                { value: 'block_checkout', label: this.$t('riccardo-deal.detail.behavior_block_checkout') },
            ];
        },

        productCriteria() {
            const criteria = new Criteria(1, 25);
            criteria.addFilter(Criteria.equals('parentId', null));
            return criteria;
        },

        summary() {
            if (!this.deal) {
                return '';
            }
            const price = this.deal.priceType === 'percent'
                ? `${this.deal.priceValue ?? 0} % Rabatt`
                : `${Number(this.deal.priceValue ?? 0).toFixed(2).replace('.', ',')} €`;
            const min = `${Number(this.deal.minQualifyingValue ?? 0).toFixed(2).replace('.', ',')} €`;
            const label = this.deal.qualifyingLabel || 'beliebigen Artikeln';
            const margin = this.deal.minMargin ? ` (nur Artikel mit mind. ${this.deal.minMargin} % Marge)` : '';
            const behavior = this.deal.behavior === 'block_checkout'
                ? 'Darunter bleibt der Deal-Preis stehen, die Bestellung ist aber gesperrt.'
                : 'Darunter gilt der reguläre Preis.';
            return `Deal-Preis: ${price} – sobald der Warenkorb mind. ${min} aus ${label}${margin} enthält. ${behavior} Max. ${this.deal.maxQuantity ?? 1} Stück pro Bestellung.`;
        },
    },

    created() {
        this.loadDeal();
    },

    methods: {
        loadDeal() {
            if (!this.dealId) {
                this.deal = this.dealRepository.create();
                this.deal.active = true;
                this.deal.priceType = 'fixed';
                this.deal.priceValue = 0;
                this.deal.maxQuantity = 1;
                this.deal.minQualifyingValue = 25;
                this.deal.behavior = 'normal_price';
                this.deal.priority = 0;
                return Promise.resolve();
            }

            this.isLoading = true;
            const criteria = new Criteria();
            criteria.addAssociation('qualifyingCategories');
            criteria.addAssociation('product');

            return this.dealRepository.get(this.dealId, Shopware.Context.api, criteria).then((deal) => {
                this.deal = deal;
            }).finally(() => {
                this.isLoading = false;
            });
        },

        onSave() {
            this.isLoading = true;
            this.isSaveSuccessful = false;

            return this.dealRepository.save(this.deal).then(() => {
                this.isSaveSuccessful = true;
                this.createNotificationSuccess({ message: this.$t('riccardo-deal.detail.saveSuccess') });
                if (!this.dealId) {
                    this.$router.push({ name: 'riccardo.deal.detail', params: { id: this.deal.id } });
                    return Promise.resolve();
                }
                return this.loadDeal();
            }).catch((error) => {
                this.createNotificationError({ message: error?.response?.data?.errors?.[0]?.detail || this.$t('riccardo-deal.detail.saveError') });
            }).finally(() => {
                this.isLoading = false;
            });
        },
    },
};
